module.exports = __webpack_public_path__ + "static/img/CMMI-L5.164f87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/qualification/CMMI-L5.png
// module id = I9Kj
// module chunks = 0